import buildFoldersNestingLevelMap from './build-folders-nesting-level-map';
import { ROOT_ID, MAX_FOLDER_NESTING_LEVEL } from '../constants/index.js';

// `withNestingLimit: false` skips the depth rule, leaving only the structural
// reasons a target is disabled (moved subtree, no-op parent).
const getDisabledMoveTargetFolderIds = ({
  folderIds,
  pageIds,
  folders,
  pages,
  withNestingLimit = true,
}) => {
  const selectedFolderIdsSet = new Set(folderIds);
  const foldersById = new Map(folders.map((folder) => [folder.id, folder]));
  const pagesById = new Map(pages.map((page) => [page.id, page]));

  const childIdsByParentId = new Map();
  folders.forEach((folder) => {
    if (!folder.parentFolderId) return;
    if (!childIdsByParentId.has(folder.parentFolderId)) {
      childIdsByParentId.set(folder.parentFolderId, []);
    }
    childIdsByParentId.get(folder.parentFolderId).push(folder.id);
  });

  const disabledFolderIds = new Set();

  const visit = (folderId) => {
    if (disabledFolderIds.has(folderId)) return;
    disabledFolderIds.add(folderId);
    (childIdsByParentId.get(folderId) || []).forEach(visit);
  };

  folderIds.forEach(visit);

  const topLevelFolders = folderIds
    .map((id) => foldersById.get(id))
    .filter((folder) => folder && !selectedFolderIdsSet.has(folder.parentFolderId));
  const topLevelPages = pageIds
    .map((id) => pagesById.get(id))
    .filter((page) => page && !selectedFolderIdsSet.has(page.parentFolderId));
  const topLevelItems = [...topLevelFolders, ...topLevelPages];

  if (topLevelItems.length) {
    const parentKeys = new Set(
      topLevelItems.map((item) =>
        item.parentFolderId && foldersById.has(item.parentFolderId) ? item.parentFolderId : ROOT_ID
      )
    );

    if (parentKeys.size === 1) {
      disabledFolderIds.add(parentKeys.values().next().value);
    }
  }

  if (withNestingLimit && topLevelFolders.length) {
    const getFolderHeight = (folderId) => {
      const childIds = childIdsByParentId.get(folderId) || [];
      return 1 + childIds.reduce((max, childId) => Math.max(max, getFolderHeight(childId)), 0);
    };

    const maxMovedHeight = Math.max(...topLevelFolders.map((folder) => getFolderHeight(folder.id)));
    const nestingLevelMap = buildFoldersNestingLevelMap(folders);

    folders.forEach((folder) => {
      if (nestingLevelMap[folder.id] + maxMovedHeight > MAX_FOLDER_NESTING_LEVEL) {
        disabledFolderIds.add(folder.id);
      }
    });
  }

  return disabledFolderIds;
};

export default getDisabledMoveTargetFolderIds;
